module.exports = __webpack_public_path__ + "img/ijin.2e4638b9.png";